import CorporateTransformer from '../../transformers/corporate';
import axios from 'axios';

export default (id) => {
  const promise = new Promise((resolve, reject) => {
    axios
      .get(`${process.env.VUE_APP_API_ADMIN_LOCATION}organizations/${id}`)
      .then(({ data }) => {
        let dataRes = {};
        if (data.data) {
          dataRes = CorporateTransformer.fetch(data.data);
        }
        resolve(dataRes);
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
